/* SAJUST source notice: draft-only customer UI. Never changes Shopify sellability. */
(() => {
  if (window.__SAJUST_PARTNER_NOTICE_LOADED__) return;
  window.__SAJUST_PARTNER_NOTICE_LOADED__ = true;
  const copy = {
    lv: {
      local:"SAJUST noliktavā",localDetail:"Šo izmēru varam sagatavot no sava krājuma.",
      partner:"Tikai partnera noliktavā",partnerDetail:"Izsūtīšana aptuveni 7–14 darba dienu laikā.",
      reserve:"Ja izvēlētais daudzums pārsniedz mūsu atlikumu, pasūtījuma izsūtīšana var aizņemt ilgāku laiku.",
      mark:"Dzeltenā atzīme — tikai partnera noliktavā",
      prop:"Piegāde",value:"Partnera noliktava — izsūtīšana aptuveni 7–14 darba dienās",
      standardPickup:"Saņemšana SAJUST veikalā pēc preces pienākšanas; paziņosim, kad tā gatava."
    },
    en: {
      local:"Available at SAJUST",localDetail:"We can prepare this size from our own stock.",
      partner:"Partner warehouse only",partnerDetail:"Estimated dispatch in 7–14 business days.",
      reserve:"If the quantity exceeds our own stock, dispatch might take longer.",
      mark:"Gold mark — partner warehouse only",
      prop:"Delivery",value:"Partner warehouse — dispatch in approximately 7–14 business days",
      standardPickup:"Collect at SAJUST once the shoes arrive; we will notify you when ready."
    }
  };
  function updateOne(root){
    const note=root.querySelector('[data-sajust-partner-notice]');
    if(!note)return;
    const lang=document.documentElement.lang?.toLowerCase().startsWith('lv')?'lv':'en', t=copy[lang];
    const form=root.querySelector('form[data-type="add-to-cart-form"]');
    const input=form?.querySelector('input[name="id"]');
    const prop=form?.querySelector('[data-sajust-supplier-property]');
    const id=String(input?.value||'');
    const quantityInput=root.querySelector('.product-form__quantity input[name="quantity"],input[name="quantity"]');
    const qty=Math.max(1,parseInt(quantityInput?.value||'1',10)||1);
    if(prop){prop.disabled=true;prop.value='';prop.name='properties['+t.prop+']';}
    let stock=[];
    try{stock=JSON.parse(root.querySelector('[data-sajust-stock-data]')?.textContent||'[]');}catch(e){}
    const choice=stock.find(v=>String(v.id)===id);
    const partnerQty=Math.max(0,Number(choice?.partner)||0);
    const totalQty=Number(choice?.total)||0;
    const localQty=Math.max(0,totalQty-partnerQty);
    // Gold partner-only size badges are rendered in Liquid, including Shopify section replacements.
    const partnerOnly=!!choice && partnerQty>0 && localQty<=0;
    const partnerNeeded=!!choice && partnerQty>0 && qty>localQty;
    const available=!!choice && choice.available===true;
    note.hidden=!(partnerOnly || partnerNeeded);
    if(!note.hidden){
      note.querySelector('.sajust-partner-inline__title').textContent=partnerOnly?t.partner:t.local;
      note.querySelector('.sajust-partner-inline__description').textContent=partnerOnly?t.partnerDetail:t.reserve;
    }
    if(partnerNeeded&&available&&prop){prop.disabled=false;prop.value=t.value;}
    const deliveryCard=root.querySelector('.sajust-delivery-card');
    if(deliveryCard){
      const partnerRow=deliveryCard.querySelector('[data-sajust-partner-benefit]');
      const pickupRow=deliveryCard.querySelector('[data-sajust-partner-pickup]');
      const standardRow=deliveryCard.querySelector('[data-sajust-standard-delivery]');
      if(partnerRow)partnerRow.hidden=!partnerNeeded;
      if(pickupRow)pickupRow.hidden=!partnerNeeded;
      // Keep the regular delivery information visible, with its qualifier "for SAJUST-stocked items".
      if(standardRow)standardRow.hidden=false;
      const pickup=deliveryCard.querySelector('pickup-availability');
      if(pickup)pickup.hidden=partnerNeeded;
      const pickupTitle=pickup?.querySelector('.pickup-availability-info .caption-large');
      const betterPickup=lang==='lv'?'Saņemšana SAJUST veikalā':'Collect at SAJUST';
      if(pickupTitle&&pickupTitle.textContent.trim()!==betterPickup)pickupTitle.textContent=betterPickup;
      deliveryCard.dataset.sajustSource=partnerOnly?'partner':partnerNeeded?'mixed':'local';
    }
  }
  function refresh(){document.querySelectorAll('product-info').forEach(updateOne);}
  document.addEventListener('change',()=>setTimeout(refresh,0));
  document.addEventListener('input',event=>{if(event.target?.matches('input[name="quantity"]'))refresh();});
  document.addEventListener('product-info:loaded',refresh);
  document.addEventListener('shopify:section:load',refresh);
  // Shopify can redraw variant/pickup fragments asynchronously; refresh after such redraws.
  const observer=new MutationObserver(records=>{
    if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1 &&
      (n.matches?.('variant-selects, pickup-availability, .pickup-availability-preview, .sajust-delivery-card')
      ||n.querySelector?.('variant-selects, pickup-availability, .pickup-availability-preview'))))){queueMicrotask(refresh);}
  });
  const observe=()=>{document.querySelectorAll('product-info').forEach(root=>observer.observe(root,{childList:true,subtree:true}));};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe,{once:true});else observe();
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange){subscribe(PUB_SUB_EVENTS.variantChange,refresh);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();